import Tabs from "@components/Tabs";
import FormProvider from "@providers/FormProvider";
import { usePageContext } from "@providers/PageProvider";
import { Form, useFormik } from "formik";
import _ from "lodash";
import helper from "@utils/helper";
import { useRouteContext } from "@providers/RouteProvider";

const View = ({ slug, mobileHide }: any) => {
  const { router } = useRouteContext();
  const { categories: storyCategories } = usePageContext();
  const categories = _.compact(_.map(storyCategories, helper.formatCategory));
  const form: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      tab: slug ?? "",
    },
    onSubmit: async () => {
      return true;
    },
  });
  const TABS: any = [];

  _.map(categories, (cat) => {
    TABS.push({
      label: cat.name,
      key: cat.slug,
      value: cat.slug,
      children: <></>,
    });
  });

  return (
    <FormProvider form={form}>
      <Form>
        <Tabs
          placeholderNoneAmin={true}
          mobileHide={mobileHide}
          border="none"
          name="tab"
          onChange={(cat: any) => {
            router.push("storiesCategory", { slug: cat });
          }}
          items={TABS}
        />
      </Form>
    </FormProvider>
  );
};
export default View;
